export const MIME_XML = 'application/xml';
export const MIME_PDF = 'application/pdf';
